exports.components = {
  "component---src-pages-edition-tsx": () => import("./../../../src/pages/edition.tsx" /* webpackChunkName: "component---src-pages-edition-tsx" */),
  "component---src-templates-introduction-tsx": () => import("./../../../src/templates/introduction.tsx" /* webpackChunkName: "component---src-templates-introduction-tsx" */)
}

